import { render, staticRenderFns } from "./accountDialog.vue?vue&type=template&id=03bd8e7a&scoped=true"
import script from "./accountDialog.vue?vue&type=script&lang=js"
export * from "./accountDialog.vue?vue&type=script&lang=js"
import style0 from "./accountDialog.vue?vue&type=style&index=0&id=03bd8e7a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bd8e7a",
  null
  
)

export default component.exports